import { useState, useEffect, useCallback, useRef } from 'react';
import { dashboardAPI } from '../../../services/api';
import { useTranslation } from 'react-i18next';

export const useDashboardData = (user, isSuperAdmin, filters) => { // FIX: Accept 'filters' as an argument
    const { t } = useTranslation();
    const [analytics, setAnalytics] = useState(null);
    const [loading, setLoading] = useState(true); // For the very first page load
    const [analyticsLoading, setAnalyticsLoading] = useState(false); // For subsequent re-fetches
    const [error, setError] = useState('');
    const [privilegeError, setPrivilegeError] = useState(false);

    // FIX: Create a ref to prevent double-fetching on initial mount due to StrictMode.
    const isFetching = useRef(false);

    // FIX: Wrap fetchAnalytics in useCallback for stability
    const fetchAnalytics = useCallback(async (filterParams = {}) => {
        // FIX: Guard clause to prevent concurrent fetches.
        if (isFetching.current) return;

        // FIX: Set the "lock" to true.
        isFetching.current = true;
        setAnalyticsLoading(true);

        try {
            const params = { ...filterParams };
            // Ensure we don't send an empty branch parameter
            if (params.branch === '') delete params.branch;

            const response = await dashboardAPI.getAnalytics({ params });
            setAnalytics(response.data.data);
            setError('');
            setPrivilegeError(false);
        } catch (err) {
            if (err.response?.status === 403) {
                setPrivilegeError(true);
            } else {
                setError(err.response?.data?.message || t('dashboard.fetchError'));
            }
        } finally {
            setAnalyticsLoading(false);
            setLoading(false); // Ensure initial loading is also turned off
            // FIX: Release the "lock" so subsequent fetches can occur.
            isFetching.current = false;
        }
    }, [t]); // Dependency on `t` for translations in error messages

    // FIX: This useEffect now correctly listens for changes to the filters object.
    useEffect(() => {
        if (user) {
            fetchAnalytics(filters);
        }
    }, [user, filters, fetchAnalytics]); // Re-run when user or filters change

    return {
        analytics,
        loading,
        error,
        analyticsLoading,
        privilegeError,
        fetchAnalytics // Still exposed for manual refresh buttons
    };
};